import React, { Component } from 'react';
import ProjectHeader from '../ProjectHeader';
import Header from '../../assets/images/headbangingbird/__header.png';
import IllustrationHeadbangingBird from '../../assets/images/headbangingbird/__illustration.png';

class ProjectHeadbangingBird extends Component {
	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Headbanging Bird</h1>
				<span className="title-caption step-4">A Flappy Bird game clone</span>
				<div className="publish-container">
					<img src={Header} alt="Caption for single image" />
					<p>
						A clone of the famous{' '}
						<a href="https://en.wikipedia.org/wiki/Flappy_Bird" aria-label="Link to Flappy Bird wikipidia's page" target="_blank" className="link">
							Flappy Bird
						</a>{' '}
						game.
						<br />It's a bit old, but it's still playable.
					</p>
					<p>
						You can check the game{' '}
						<a href="https://www.room.pt/game" aria-label="Link to game" target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" href="https://www.room.pt/game">
						<img to="/" src={IllustrationHeadbangingBird} alt="Headbanging Bird game illustration" />
					</a>
					<p>Thank you.</p>
				</div>
			</div>
		);
	}
}

export default ProjectHeadbangingBird;
